export const routes = {
    event:{
        create : "/evento/criar",
        all: "/todos"
    },
    auth: {
        login : "/login"
    },
    contact : "/contato",
    user: {
        admin: "/admin",
        perfil: "/perfil",
    },
    ranking: "/ranking"
}